import { apiService } from "./apiService";



export const authservice = {
    login: (data: { email: string; password: string }) =>
        apiService.post('/api/auth/login', data, 'backend'),

    lookupSso: (email: string) =>
        apiService.post('/api/auth/sso/lookup', { email }, 'backend'),

    listSsoProviders: () =>
        apiService.get('/api/auth/sso/providers', {}, 'backend'),

    deleteUser: (userId: string, tenantId: string) =>
        apiService.post('/api/auth/roles/removeuser', { userId, tenantId }, 'backend'),
    updatePassword: (userId: string, newPassword: string, tenantId: string) =>
        apiService.post('/api/auth/users/update-password', { userId, newPassword, tenantId }, 'backend'),
    getUsers: () =>
        apiService.get('/api/auth/users', {}, 'backend'),
    registerUser: (data: any) =>
        apiService.post('/api/auth/register', data, 'backend'),

    getSingleUser: (tenantId: string, userId: string) =>
        apiService.post('/api/auth/getSingleUser', { userID: userId, tenantId }, 'backend'),

    getUserDetail: (userId: string) =>
        apiService.get(`/api/auth/users/${userId}`, {}, 'backend'),

    editUser: (data: any) =>
        apiService.post('/api/auth/users/edit', data, 'backend'),
    getRoles: () => apiService.get('/api/auth/roles/users', {}, 'backend'),

}